"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const _1 = require(".");
function default_1() {
    const [showWithdrawRequestDialog, setShowWithdrawRequestDialog] = (0, react_1.useState)(false);
    const openWithdrawRequestDialog = () => setShowWithdrawRequestDialog(true);
    const closeWithdrawRequestDialog = () => setShowWithdrawRequestDialog(false);
    (0, webview_app_1.useAABBDialogClose)({
        open: showWithdrawRequestDialog,
        closeDialog: closeWithdrawRequestDialog,
    });
    const { id: roomId, room_type_cd, room_status_cd, entered_waybill_count, } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    const isLimitedSales = room_type_cd === 'ROOM_TYPE_00';
    const isPaymentComplete = room_status_cd === 'ROOM_STATUS_02';
    const isShippingComplete = room_status_cd === 'ROOM_STATUS_05';
    const isBuyerInfoDiscarded = room_status_cd === 'ROOM_STATUS_06';
    const { total_withdrawable_amount, total_reward_amount } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementTotalAmountState);
    const settlementRewardSelect = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementRewardSelectState);
    const isRewardKeep = settlementRewardSelect === 'keep';
    const isRewardShare = settlementRewardSelect === 'share';
    // ? [버튼] 제작비 정산(중간 정산)
    // ROOM_TYPE_00(기간이 정해진 판매=굿즈) 일 때 표시
    // ROOM_STATUS_02(모금완료) 일 때 활성화
    // 그 외에는 비활성화
    // ? [버튼] 정산(잔액 정산)
    // ROOM_STATUS_05(배송 완료) OR ROOM_STATUS_06(진행 완료) 일 때 활성화
    // entered_waybill_count > 0 일 때 활성화
    // 그 외에는 비활성화
    // ! [버튼] 정산(사비지킴이> 내가받기)
    // isRewardKeep && isBuyerInfoDiscarded && !total_withdrawable_amount 일 때 활성화
    const isPaymentSettlementable = !!total_withdrawable_amount && isPaymentComplete;
    const isBalanceSettlement = !!total_withdrawable_amount &&
        (isShippingComplete || isBuyerInfoDiscarded || entered_waybill_count > 0);
    const isRewardKeepSettlement = !total_withdrawable_amount && !!total_reward_amount && isBuyerInfoDiscarded;
    const isSettlementable = isBalanceSettlement || isRewardKeepSettlement;
    const goToWithdrawRequestPage = () => {
        window.location.href = `/room/withdraw-request/${roomId}`;
    };
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onRewardKeepClick = () => {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('내가 받기로 정산 접수하면'), (0, jsx_runtime_1.jsx)("br", {}), t('구매자 나눔할 수 없어요. 진행하시겠어요?')] })),
            confirmationText: t('정산 접수'),
        })
            .then(goToWithdrawRequestPage)
            .catch(() => { });
    };
    const onWithdrawRequestClick = isRewardKeepSettlement
        ? onRewardKeepClick
        : isBuyerInfoDiscarded
            ? goToWithdrawRequestPage
            : openWithdrawRequestDialog;
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    if (!roomId)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    maxWidth: '1024px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "sticky-btn-bg", css: {
                        width: maxWidth768 ? '100%' : 'calc(100% - 324px)',
                        display: 'flex',
                        columnGap: '10px',
                        padding: '60px 16px 32px',
                    } }, { children: [isLimitedSales && ((0, jsx_runtime_1.jsx)(_1.SettlementButton, Object.assign({ component: "a", href: `/room/payment-request/${roomId}`, disabled: !isPaymentSettlementable }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('제작비 정산') })) }))), isRewardKeep && ((0, jsx_runtime_1.jsx)(_1.SettlementButton, Object.assign({ onClick: onWithdrawRequestClick, disabled: !isSettlementable }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle2" }, { children: t('정산') })) }))), isRewardShare && (0, jsx_runtime_1.jsx)(_1.RewardShareButton, {})] })) })), (0, jsx_runtime_1.jsx)(_1.WithdrawRequestWarningDialog, { open: showWithdrawRequestDialog, closeDialog: closeWithdrawRequestDialog, goToWithdrawRequestPage: goToWithdrawRequestPage })] }));
}
exports.default = default_1;
